<template>
  <b-modal v-model="showModal" centered header-class="custom-modal-header" hide-footer>
    <template #modal-title>
      <p class="text-header">Choose Platform</p>
    </template>
    <div class="text-center py-3">
      <b-button variant="platform" @click="handleLINE()" :disabled="platformIdList.includes(1)">
        <img src="@/assets/images/icons/line.png"
      /></b-button>
      <b-button variant="platform" :disabled="platformIdList.includes(4)" @click="handleFB()" class="mx-3">
        <img src="@/assets/images/icons/facebook.png" />
      </b-button>
      <b-button variant="platform" :disabled="platformIdList.includes(5)" @click="handleIG()">
        <img src="@/assets/images/icons/instagram.png" />
      </b-button>
      <b-button variant="platform" :disabled="platformIdList.includes(6)" @click="handleWhatApp()">
        <img src="@/assets/images/icons/whatsapp.png" width="98" height="98" />
      </b-button>

      <b-button variant="platform" :disabled="platformIdList.includes(7)" @click="handleShopee()">
        <img src="@/assets/images/icons/Shopee-logo.png" width="98" height="98" />
      </b-button>
    </div>
    <ModalSelectPageFacebook
      ref="modalSelectPageFacebook"
      :v="$v.selectedPage"
      :pages="pages"
      @handleSelectedPage="handleSelectedPage"
    />
    <ModalSelectWhatsApp
      ref="modalSelectWhatsApp"
      :v="$v.selectedPage"
      :pages="pages"
      @handleSelectedWhatsApp="handleSelectedWhatsApp"
    />
  </b-modal>
</template>

<script>
import ModalSelectPageFacebook from "./ModalSelectPageFacebook.vue";
import ModalSelectWhatsApp from "./ModelSelectWhatsApp.vue";
import { required } from "vuelidate/lib/validators";

export default {
  name: "ModalCreatePlatform",
  components: {
    ModalSelectPageFacebook,
    ModalSelectWhatsApp,
  },
  props: {},
  validations() {
    return {
      selectedPage: {
        id: { required },
      },
    };
  },
  data: function () {
    return {
      appId: this.$facebookAppId,
      secret: this.$facebookSecret,
      version: "v12.0",
      selectPlatformId: 1,
      selectedPage: {
        url: null,
        name: "",
        access_token: "",
        picture: {
          data: {
            url: "",
            name: null,
            access_token: null,
            picture: null,
            id: null,
          },
        },
        id: "",
        instagram_business_account: {
          id: null,
        },
      },
      pages: [],
      profile: {},
      authorized: false,
      authResponse: null,
      wabaId: "",
      connected: true,
      showModal: false,
      isShowPage: false,
      isShowWhatsApp: false,
      page: null,
      getPageToken: null,
      isLoading: false,
    };
  },
  props: {
    platformIdList: {
      required: false,
      type: Array,
    },
  },
  async created() {
    try {
      var _this = this;
      window.addEventListener("message", this.whatsappEventListing);
      window.fbAsyncInit = function () {
        FB.init({
          appId: _this.appId,
          cookie: true,
          xfbml: true,
          version: _this.version,
        });
        FB.getLoginStatus(({ authResponse }) => {
          console.log("getLoginStatus ", authResponse);
        });

        FB.AppEvents.logPageView();
      };

      (function (d, s, id) {
        var js,
          fjs = d.getElementsByTagName(s)[0];
        if (d.getElementById(id)) {
          return;
        }
        js = d.createElement(s);
        js.id = id;
        js.src = "https://connect.facebook.net/en_US/sdk.js";
        fjs.parentNode.insertBefore(js, fjs);
      })(document, "script", "facebook-jssdk");
    } catch (error) {
      console.log("connect error ", error);
    }
  },
  methods: {
    whatsappEventListing(event) {
      if (event.origin !== "https://www.facebook.com" && event.origin !== "https://web.facebook.com") {
        return;
      }
      try {
        const data = JSON.parse(event.data);
        if (data.type === "WA_EMBEDDED_SIGNUP") {
          if (data.event == "FINISH_GRANT_ONLY_API_ACCESS") {
            this.confirmSelectWhatsApp(data.data.waba_ids[0]);
          }
        }
      } catch {
        console.log("Non JSON Responses", event.data);
      }
    },
    onCloseModal() {
      this.showModal = false;
    },
    handleLINE() {
      this.selectPlatformId = 1;
      this.$emit("handleLINE");
    },
    handleFB() {
      this.selectPlatformId = 4;
      let vm = this;
      FB.login(
        function (response) {
          console.log("login", response);
          vm.statusChangeCallback(response);
        },
        {
          //pages_read_engagement, pages_manage_metadata,   pages_manage_posts, pages_manage_engagement, pages_read_user_content
          scope:
            "email, public_profile, pages_show_list, pages_messaging, pages_manage_engagement, pages_read_user_content, pages_read_engagement, pages_manage_metadata",
          return_scopes: false,
        },
      );
    },
    handleIG() {
      this.selectPlatformId = 4;
      let vm = this;
      FB.login(
        function (response) {
          console.log("login", response);
          vm.statusChangeCallback(response);
        },
        {
          //email, public_profile, pages_show_list, pages_messaging,pages_manage_engagement, pages_read_user_content, instagram_basic, instagram_manage_messages, pages_read_engagement, pages_manage_metadata
          scope:
            "pages_show_list, pages_manage_metadata, pages_read_engagement, instagram_basic, instagram_manage_messages",
          return_scopes: false,
        },
      );
    },
    handleWhatApp() {
      this.selectPlatformId = 6;
      let vm = this;
      FB.login(
        function (response) {
          vm.whatsAppStatusChangeCallback(response);
        },
        {
          config_id: "1055673616238632", // configuration ID goes here
          response_type: "code", // must be set to 'code' for System User access token
          override_default_response_type: true, // when true, any response types passed in the "response_type" will take precedence over the default types
          extras: {
            setup: {},
            sessionInfoVersion: "2",
          },
        },
      );
    },

    async handleShopee() {
      this.selectPlatformId = 7;
      let result = await this.axios.get(`${this.$baseUrl}/shopee/OauthShopee`);
      if (result.result == 1) {
        // open new window
        // เปิดหน้าต่างใหม่
        const popup = window.open(result.detail, "_blank", "width=600,height=700");

        // สร้าง Promise ที่รอ message จาก window ที่ถูกเปิด
        const token = await new Promise((resolve, reject) => {
          const messageListener = (event) => {
            // ตรวจสอบ message และปิด popup
            if (event.data?.result) {
              window.removeEventListener("message", messageListener);
              popup.close();
              resolve(event.data.result);
            }
          };

          window.addEventListener("message", messageListener);
        });
        console.log("🚀 ~ token ~ token:", token)
      } else {
        this.$store.commit("UPDATE_GLOBAL_ALERT_ERROR", {
          isShow: true,
          msg: result.message,
        });
      }
    },

    logoutFB() {
      let vm = this;
      FB.logout(function (response) {
        vm.statusChangeCallback(response);
      });
    },
    async whatsAppStatusChangeCallback(response) {
      let vm = this;
      vm.authResponse = response.authResponse;
      this.$store.commit("UPDATE_MAIN_LOADING", true);
      this.onCloseModal();
      await this.axios
        .post(`${this.$baseUrl}/livePost/ConnectWhatsApp`, {
          code: this.authResponse.code,
          wabaId: this.wabaId,
        })
        .then((data) => {
          if (data.result === 1) {
            this.$store.commit("UPDATE_MAIN_LOADING", false);
            this.$emit("reloadData");
          } else
            this.$store.commit("UPDATE_GLOBAL_ALERT_ERROR", {
              isShow: true,
              msg: data.message,
            });
        })
        .catch((err) => {
          this.$store.commit("UPDATE_MAIN_LOADING", false);
          this.$store.commit("UPDATE_GLOBAL_ALERT_ERROR", {
            isShow: true,
            msg: err.message,
          });
        });
    },
    statusChangeCallback(response) {
      let vm = this;
      if (response.status === "connected") {
        vm.authorized = true;
        vm.authResponse = response.authResponse;
        vm.authorized = response.authResponse;
        vm.getProfileFB();
        vm.connected = true;
      } else if (response.status === "not_authorized") {
        vm.authorized = false;
      } else if (response.status === "unknown") {
        vm.profile = {};
        vm.authorized = false;
      } else {
        vm.authorized = false;
      }
    },
    getProfileFB: async function () {
      let vm = this;
      await FB.api("/me?fields=name,id,email", (response) => {
        console.log("get me", response);
        FB.api(
          `/oauth/access_token?grant_type=fb_exchange_token&client_id=${vm.appId}&client_secret=${vm.secret}&fb_exchange_token=${vm.authResponse.accessToken}`,
          (res) => {
            console.log("get profile", res);
            vm.getPageToken = res.access_token;
            console.log("get page token", vm.getPageToken);
            console.log("token", vm.authResponse.accessToken);
            vm.getPages();
          },
        );
      });
    },
    async getPages() {
      await this.axios
        .post(`${this.$baseUrl}/livePost/facebookPage`, {
          psid: this.authResponse.userID,
          userToken: this.getPageToken,
        })
        .then((data) => {
          if (data.result === 1) {
            this.isShowPage = false;
            this.pages = data.detail;
            this.handleModalSelectPageFacebookShow();
          } else
            this.$store.commit("UPDATE_GLOBAL_ALERT_ERROR", {
              isShow: true,
              msg: data.message,
            });
        })
        .catch((err) => {
          this.$store.commit("UPDATE_GLOBAL_ALERT_ERROR", {
            isShow: true,
            msg: err.message,
          });
        });
    },
    handleModalSelectPageFacebookShow() {
      this.$v.selectedPage.$reset();
      this.selectedPage = {
        url: null,
        name: "",
        access_token: "",
        picture: {
          data: {
            url: "",
            name: null,
            access_token: null,
            picture: null,
            id: null,
          },
        },
        id: "",
        instagram_business_account: {
          id: null,
        },
      };
      this.$refs.modalSelectPageFacebook.onShowModal();
    },

    handleModalSelectWhatsAppShow() {
      this.$v.selectedPage.$reset();
      this.selectedPage = {};
      this.$refs.modalSelectWhatsApp.onShowModal();
    },
    handleSelectedPage(val) {
      this.selectedPage = val;

      this.$v.selectedPage.$touch();
      if (this.$v.selectedPage.$error) return;

      this.confirm();
    },

    handleSelectedWhatsApp(val) {
      this.selectedPage = val;

      this.$v.selectedPage.$touch();
      if (this.$v.selectedPage.$error) return;
    },
    async confirmSelectWhatsApp(wabaId) {
      this.wabaId = wabaId;
    },
    async confirm() {
      let body = {
        id: 0,
        pageid: this.selectedPage.id,
        name: this.selectedPage.name,
        tokenfacebook: this.selectedPage.access_token,
        pictureUrl: this.selectedPage.picture.data.url,
        InstagramId: this.selectedPage.instagram_business_account
          ? this.selectedPage.instagram_business_account.id
          : null,
        instagramName: this.selectedPage.instagram_business_account
          ? this.selectedPage.instagram_business_account.username
          : null,
        instagramPicture: this.selectedPage.instagram_business_account
          ? this.selectedPage.instagram_business_account.profile_picture_url
          : null,
      };
      await this.axios
        .post(`${this.$baseUrl}/livePost/updateFacebookPage`, body)
        .then((data) => {
          console.log("update facebook page", data);
          if (data.detail == 1) {
            this.$refs.modalSelectPageFacebook.onCloseModal();
            this.$emit("reloadData");
            this.onCloseModal();
          } else {
            this.$store.commit("UPDATE_GLOBAL_ALERT_ERROR", {
              isShow: true,
              msg: data.message,
            });
          }
        })
        .catch((err) => {
          this.$store.commit("UPDATE_GLOBAL_ALERT_ERROR", {
            isShow: true,
            msg: err.message,
          });
        });
    },
  },
};
</script>
